import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import { actions as photoActions } from '@ff-scene-plugins/photo-prints-redux/slices/photosSlice';
import { PhotoPrintsPdpDispatch, PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { PhotoPrintsJson } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsJson';
import { selectPhotoStatusById, selectQuantityById } from '../../../_redux-photos';
import { PhotoPrintMobileOverlay } from './PhotoPrintMobileOverlay';
import { PhotoPrintPreviewMobile } from './PhotoPrintPreviewMobile';
import styles from './PhotoPrintMobile.module.scss';

const _PhotoPrintMobile = ({
    photoId, onMoveOrCopy, status
}: Props) => {

    const [isOpen, setOpen] = useState(false);

    if (status === 'error') {
        return <PhotoPrintPreviewMobile id={photoId} />;
    }

    return (
        <PhotoPrintPreviewMobile id={photoId} onClick={() => setOpen(true)}>
            <div className={styles.default}>

                <div className={styles.iconContainer}>
                    <Icon type='general-ui-brush' className={styles.icon} strokeWidth={2} />
                </div>

                <PhotoPrintMobileOverlay photoId={photoId}
                    isOpen={isOpen}
                    setOpen={setOpen}
                    onMoveOrCopy={onMoveOrCopy} />
            </div>
        </PhotoPrintPreviewMobile>
    );
};

type OwnProps = {
    photoId: string;
    onMoveOrCopy: () => void;
};

type Props = OwnProps & {
    quantity: number;
    setQuantity: (quantity: number) => void;
    removePhoto: () => void;
    status: PhotoPrintsJson.ProcessedPhoto['status'];
};

const mapStateToProps = (state: PhotoPrintsPdpState, ownProps: OwnProps) => ({
    quantity: selectQuantityById(state, ownProps.photoId),
    status: selectPhotoStatusById(state, ownProps.photoId)!
});

const mapDispatchToProps = (dispatch: PhotoPrintsPdpDispatch, ownProps: OwnProps) => ({
    removePhoto: () => dispatch(photoActions.remove(ownProps.photoId)),
    setQuantity: (quantity: number) => dispatch(photoActions.setQuantity({
        photoId: ownProps.photoId,
        quantity: quantity
    }))
});

export const PhotoPrintMobile = connect(
    mapStateToProps,
    mapDispatchToProps
)(_PhotoPrintMobile);